const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ShippingCommand: any = {
    UpsertShippingCompanyCostForDesi: Backofficebff + '/v1/shipping/upsert-shipping-company-cost-for-desi',
    UpsertBulkShippingCompanyCostForDesi: Backofficebff + '/v1/shipping/upsert-bulk-shipping-company-cost-for-desi',
    UpsertSellerShipmentCosts: Backofficebff + '/v1/shipping/update-seller-shipment-cost',
    DeleteSellerShipmentCosts: Backofficebff + '/v1/shipping/delete-seller-shipment-costs',
    InsertBulkSellerShipmentCostsExcel: Backofficebff + '/v1/shipping/insert-bulk-seller-shipment-cost-excel',
};
